export const apiBaseUrl = process.env.REACT_APP_API_URL_STAGING;
